import i18next from 'i18next';

import sortActionsList from '@commons/utils/sortActionsList';

const PENDING_STATUS = 'PENDING';

export const getRowActionsSettings = ({ stopTask }) => {
  const rowActions = [
    {
      id: 'stop-task',
      actionLabel: () => i18next.t('BACKOFFICE.TASKS.STOP'),
      handleAction: ({ id }) => stopTask(id),
      actionIcon: () => '/images/icon-cross-close-black.svg',
      isHidden: ({ formattedStatus }) => formattedStatus.status !== PENDING_STATUS,
    },
  ];

  return sortActionsList(rowActions);
};

export default {
  getRowActionsSettings,
};
